import { PLAN_REWARDS } from "@/contexts/ReferralContext";
import { UserPlus, CreditCard, Star, Zap } from "lucide-react";

export default function PlanRewardTiers() {
  return (
    <div className="p-5 rounded-lg bg-card border border-border shadow-card">
      <h3 className="text-sm font-semibold text-foreground mb-3">How Rewards Work</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <div className="p-3 rounded-lg bg-accent/5 border border-accent/20">
          <UserPlus className="h-5 w-5 text-accent mb-2" />
          <p className="text-sm font-semibold text-foreground">Friend Signs Up</p>
          <p className="text-xs text-muted-foreground mt-0.5">₹100 added to your wallet</p>
        </div>
        {Object.entries(PLAN_REWARDS).map(([key, val]) => {
          const icons = { starter: CreditCard, professional: Star, enterprise: Zap };
          const colors = { starter: "success", professional: "warning", enterprise: "accent" };
          const Icon = icons[key as keyof typeof icons] || CreditCard;
          const color = colors[key as keyof typeof colors] || "accent";
          return (
            <div key={key} className={`p-3 rounded-lg bg-${color}/5 border border-${color}/20`}>
              <Icon className={`h-5 w-5 text-${color} mb-2`} />
              <p className="text-sm font-semibold text-foreground">{val.label} Purchase</p>
              <p className="text-xs text-muted-foreground mt-0.5">₹{val.amount} wallet reward</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
